((ProductCount, $) => {
  'use strict';

  const API = 'https://product-hit-counter-fl.herokuapp.com/api/';

  let $countContainer;
  let $numberElement;

  const cacheDom = () => {
    $countContainer = $('.product-count');
    $numberElement = $countContainer.find('[data-product-count]');
  }

  const accessAPI = (product) => {
    $.ajax({
      url: `${API}count/${product.product.id}`,
      dataType: 'json',
      success: function(data) {
        if (data.length < 1) {
          createProduct(product);
        } else {
          updateProduct(product);
        }
      }
    });
  };

  const setCount = (number) => {
    $numberElement.html(number).show().css('display', 'inline-block');
  };

  const getCount = (counts) => {
    while (counts.length > 30) {
      counts.splice(0, 1);
    }

    let total = 0;
    for (let i = 0; i < counts.length; i++) {
      total += parseInt(counts[i].count, 10);
    }
    return total;
  };

  const createProduct = (product) => {
    $.ajax({
      url: `${API}create/${product.product.id}`,
      method: 'POST',
      dataType: 'json',
      success: (data) => {
        setCount(getCount(data.counts));
      }
    });
  };

  const updateProduct = (product) => {
    $.ajax({
      url: `${API}update/${product.product.id}`,
      method: 'POST',
      success: (data) => {
        setCount(getCount(data[0].counts));
      }
    });
  };

  const pullProduct = () => {
    $.ajax({
      url: `${window.location}.json`,
      dataType: 'json',
      success: (product) => {
        accessAPI(product);
      }
    });
  };

  const run = () => {
    pullProduct();
  };

  const init = () => {
    cacheDom();
    run();
  };

  ProductCount.init = init;
})(window.ProductCount = window.ProductCount || {}, jQuery);
